import { render } from "./SideNav.vue?vue&type=template&id=7397edf6"
import script from "./SideNav.vue?vue&type=script&lang=js"
export * from "./SideNav.vue?vue&type=script&lang=js"

import "./SideNav.vue?vue&type=style&index=0&id=7397edf6&lang=css"
script.render = render

export default script